import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBar as FluentMessageBar, MessageBarTitle, MessageBarBody, makeStyles, tokens } from "@fluentui/react-components";
import { Link } from "./link";
import { AccordionSectionItem } from "./accordion";
const useClasses = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalS, // 8px
    },
});
export const MessageBar = (props) => {
    MessageBar.displayName = "MessageBar";
    const { message, title, intent, docLink, staticItem } = props;
    const classes = useClasses();
    return (_jsx(AccordionSectionItem, { uniqueId: title ?? message, staticItem: staticItem ?? true, children: _jsx("div", { className: classes.container, children: _jsx(FluentMessageBar, { intent: intent, layout: "multiline", children: _jsxs(MessageBarBody, { children: [title && _jsx(MessageBarTitle, { children: title }), message, docLink && (_jsxs(_Fragment, { children: [" - ", _jsx(Link, { url: docLink, value: "Learn More" })] }))] }) }) }) }));
};
//# sourceMappingURL=messageBar.js.map